import { createClient } from '@supabase/supabase-js';

import { Database } from '@core';

const isFloor = import.meta.env['VITE_IS_FLOOR'];
const boothOrFloorPrefix = isFloor ? `elva-floor` : `elva-booth`;

export const USER_AUTH_STATE_STORAGE_KEY = `${boothOrFloorPrefix}.user.auth`;

export const supabaseClient = createClient<Database>(
    import.meta.env['VITE_PUBLIC_SUPABASE_URL'],
    import.meta.env['VITE_PUBLIC_SUPABASE_ANON_KEY'],
    {
        auth: {
            storageKey: USER_AUTH_STATE_STORAGE_KEY,
        },
    },
);

const BOOTH_AUTH_STATE_STORAGE_KEY = `${boothOrFloorPrefix}.auth`;

export const supabaseBoothClient = createClient<Database>(
    import.meta.env['VITE_PUBLIC_SUPABASE_URL'],
    import.meta.env['VITE_PUBLIC_SUPABASE_ANON_KEY'],
    {
        auth: {
            storageKey: BOOTH_AUTH_STATE_STORAGE_KEY,
        },
    },
);
